module.exports = __webpack_public_path__ + "img/social-media-color-blocks-lincoln.4e6e208c.png";